<template>
<div>
        <card :title="title" :subTitle="subtitle" v-if="tick === 1" id="frame">
            <div class="table-responsive">
                <div class="w3-padding w3-white notranslate">
                <table class="table table-striped">
                <thead class="thead-dark">
                    <tr>
                        <th>Bezeichnung</th>
                        <th>Menge</th>
                        <th>Preis</th>
                    </tr>
                </thead>
                <tbody>  
                    <tr>
                        <td><input type="text" class="form-control" id="input1" v-model="bez1" ></td>
                        <td><input type="number" class="form-control" id="inputmenge" v-model="menge1"> </td>
                        <td><input class="form-control" type="number" id="inputmenge" v-model="preis1" step=".01"></td>
                    </tr>
                    <tr>
                        <td><input type="text" class="form-control" id="input4" v-model="bez2"></td>
                        <td><input type="number" class="form-control" id="inputmenge" v-model="menge2" ></td>
                        <td><input class="form-control" type="number" id="inputmenge" v-model="preis2" step=".01"></td>
                    </tr>
                    <tr>
                        <td><input type="text" class="form-control" id="input7" v-model="bez3"></td>
                        <td><input type="number" class="form-control" id="inputmenge" v-model="menge3" ></td>
                        <td><input class="form-control" type="number" id="inputmenge" v-model="preis3" step=".01"></td>
                    </tr>
                    <tr>
                        <td><input type="text" class="form-control" id="input10" v-model="bez4"></td>
                        <td><input type="number" class="form-control" id="inputmenge" v-model="menge4" ></td>
                        <td><input class="form-control" type="number" id="inputmenge" v-model="preis4" step=".01"></td>
                    </tr>
                    <tr>
                        <td><input type="text" class="form-control" id="input13" v-model="bez5"></td>
                        <td><input type="number" class="form-control" id="inputmenge" v-model="menge5" ></td>
                        <td><input class="form-control" type="number" id="inputmenge" v-model="preis5" step=".01"></td>
                    </tr>
                </tbody>
                </table>
             </div>  
            </div>
            <button class="btn btn-sm btn-success float-right" v-on:click="nextTick()" type="button">bestätigen</button>
        </card>
    <card :title="title" :subTitle="subtitle" v-if="tick === 2" id="frame">        
        <div class='table-responsive'>
            <table class="table table-striped">
                <thead class="thead-dark">
                <tr>
                    <th>Bez. &nbsp;</th>
                    <th>Menge   </th>
                    <th>Preis   </th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="bez1">
                    <td>{{bez1}}</td>
                    <td>{{menge1}}  Stk.</td>
                    <td>€ {{value1}}</td>
                </tr>
                <tr v-if="bez2">
                    <td>{{bez2}}</td>
                    <td>{{menge2}} Stk.</td>
                    <td>€ {{value2}}</td>
                </tr>
                <tr v-if="bez3">
                    <td>{{bez3}}</td>
                    <td>{{menge3}}Stk.</td>
                    <td>€ {{value3}}</td>
                </tr>
                <tr v-if="bez4">
                    <td>{{bez4}}</td>
                    <td>{{menge4}}Stk.</td>
                    <td>€ {{value4}}</td>
                </tr>
                <tr v-if="bez5">
                    <td>{{bez5}}</td>
                    <td>{{menge5}}Stk.</td>
                    <td>€ {{value5}}</td>
                </tr>
                <tr>
                    <td></td>
                    <td><b>Warenwert: &nbsp;</b></td>
                    <td><b>€ {{summe}}</b></td>
                </tr>
                </tbody>
            </table>
            </div> 
            <button class="btn btn-sm btn-danger float-left" v-on:click="cancel()" type="button">korrigieren</button>    
            <button class="btn btn-sm btn-success float-right" :disabled="sendButtonDisabled" v-on:click="nextTick()" type="button">absenden</button> 
        </card>

        <div class="alert alert-success" v-if="tick === 3" id="alert">
            <button type="button" aria-hidden="true" class="close"></button>
            <span>
            <b>Erfolgreich versendet! - </b> Eine entsprechende E-Mail wurde erstellt und versendet.</span>
        </div>
</div>
</template>

<script>

export default {
  components: {

  },
  data() {
    return {
        title: "Warenrücknahme",
        subtitle: "",
        tick: 1,
        bez1:"",
        bez2:"",
        bez3:"",
        bez4:"",
        bez5:"",
        menge1:"",
        menge2:"",
        menge3:"",
        menge4:"",
        menge5:"",
        preis1:"",
        preis2:"",
        preis3:"",
        preis4:"",
        preis5:"",
        value1:"",
        value2:"",
        value3:"",
        value4:"",
        value5:"",
        summe: 0,
        kunde: {},
        sendButtonDisabled: false,
    };
  },
  methods: {
    fetchCustomer(){
        this.kundennr = this.$route.params.kundennr;    
         this.$http.post(process.env.VUE_APP_PHP_API_URL+'/kunden/'+ this.kundennr, {auth: process.env.VUE_APP_PHP_AUTH})
            .then(function(kunde){
                this.kunde = kunde.body;
                if (this.kunde.Firma.length < 2) {
                    this.subtitle = this.kunde.Nachname;
                }
                else{
                    this.subtitle = this.kunde.Firma;
                }
            });
    },
    nextTick(){
        this.tick =  this.tick + 1;
        if (this.tick === 2) {
            this.calculate();
        } else if (this.tick === 3) {
            this.send();
        }
    },
    cancel(){
         this.tick =  this.tick = 1;
    },
    calculate(){
        this.value1 = this.menge1 * this.preis1;
        this.value2 = this.menge2 * this.preis2;
        this.value3 = this.menge3 * this.preis3;
        this.value4 = this.menge4 * this.preis4;
        this.value5 = this.menge5 * this.preis5;
        this.summe = this.value1 + this.value2 +this.value3 + this.value4 + this.value5
    },
    send(){
        this.sendButtonDisabled = true;
        //send data to api
        
        if (this.bez1 == ""){
                this.bez1 = "-";
            }
            if (this.menge1 == ""){
                this.menge1 = 0;
            }
            if (this.preis1 == ""){
                this.preis1 = 0;
            }
            if (this.bez2 == ""){
                this.bez2 = "-";
            }
            if (this.menge2 == ""){
                this.menge2 = 0;
            }
            if (this.preis2 == ""){
                this.preis2 = 0;
            }
            if (this.bez3 == ""){
                this.bez3 = "-";
            }
            if (this.menge3 == ""){
                this.menge3 = 0;
            }
            if (this.preis3 == ""){
                this.preis3 = 0;
            }
            if (this.bez4 == ""){
                this.bez4 = "-";
            }
            if (this.menge4 == ""){
                this.menge4 = 0;
            }
            if (this.preis4 == ""){
                this.preis4 = 0;
            }
            if (this.bez5 == ""){
                this.bez5 = "-";
            }
            if (this.menge5 == ""){
                this.menge5 = 0;
            }
            if (this.preis5 == ""){
                this.preis5 = 0;
            }
         let data = {
                input1: this.bez1,
                input2: this.menge1,
                input3: this.preis1,
                input4: this.bez2,
                input5: this.menge2,
                input6: this.preis2,
                input7: this.bez3,
                input8: this.menge3,
                input9: this.preis3,
                input10: this.bez4,
                input11: this.menge4,
                input12: this.preis4,
                input13: this.bez5,
                input14: this.menge5,
                input15: this.preis5,
                kundennummer: this.kunde.Kunden_Nr,
                firma: this.kunde.Firma,
                hausnummer: this.kunde.Hausnummer,
                nachname: this.kunde.Nachname,
                vorname: this.kunde.Vorname,
                plz: this.kunde.PLZ,
                strasse: this.kunde.Strasse,
                stadt: this.kunde.Stadt,
                email: this.kunde["E-Mail"],
                auth: process.env.VUE_APP_PHP_AUTH
            };
            this.$http.post(process.env.VUE_APP_PHP_API_URL+'/warenrueckgabe', data).then(response => {  
                if(response.status == '200'){
                console.log(response)
                setTimeout( () => this.$router.push({ path: '/tagestour'}), 2500);
                }
            });     
            
    }
  },

  created: function(){
      this.fetchCustomer();
  },
  // updated: function(){
  // }
};
</script>

<style scoped>
#inputmenge{
    width: 100%;
}
#frame{
    margin-left: 0%;
}
</style>


